const SYSTEM_FONTS = new Set([
  'Arial', 'Helvetica', 'Georgia', 'Times New Roman', 'Courier New',
  'Verdana', 'Trebuchet MS', 'Impact', 'Comic Sans MS',
  'sans-serif', 'serif', 'monospace', 'cursive', 'fantasy',
]);

const loaded = new Set();

export function loadGoogleFont(family) {
  if (!family || SYSTEM_FONTS.has(family) || loaded.has(family)) return;
  loaded.add(family);
  const encoded = encodeURIComponent(family);
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = `https://fonts.googleapis.com/css2?family=${encoded}:wght@300;400;500;600;700;800;900&display=swap`;
  document.head.appendChild(link);
}

export function loadFontsFromStory(story) {
  if (!story?.pages) return;
  for (const page of story.pages) {
    for (const layer of page.layers || []) {
      if (layer.data?.type === 'text' && layer.data?.style?.fontFamily) {
        loadGoogleFont(layer.data.style.fontFamily);
      }
    }
  }
}
